module.exports = __webpack_public_path__ + "static/media/amplifier2.365286ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/backgrounds/amplifier2.png
// module id = 177
// module chunks = 0